import { ToggleVerticalChevronButton } from '@rd-web-markets/shared/dist/util/buttons/ToggleVerticalChevronButton';
import React from 'react';
export default function CommercialProjectToggle(_ref) {
  let {
    costFragment,
    onToggleExpand,
    isExpanded
  } = _ref;
  if (costFragment.isTotalsRow) {
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  }
  if (!['project', 'program_commercial_project'].includes(costFragment.claim_project_report.program_type)) {
    return /*#__PURE__*/React.createElement("div", {
      className: "cost-fragment-toggle-row-child"
    }, /*#__PURE__*/React.createElement("div", {
      className: "cost-fragment-toggle-row-child-content"
    }));
  }
  if (costFragment.claim_project_report.program_type !== 'program_commercial_project') {
    return /*#__PURE__*/React.createElement("div", null);
  }
  return /*#__PURE__*/React.createElement("div", {
    className: isExpanded ? 'cost-fragment-row-expanded' : ''
  }, /*#__PURE__*/React.createElement(ToggleVerticalChevronButton, {
    expanded: !!isExpanded,
    onClick: () => {
      if (onToggleExpand) {
        onToggleExpand();
      }
    }
  }));
}